import { lazy, ReactNode, Suspense } from 'react';
import { BaseIssue } from 'valibot';

import { Skeleton } from '@mui/material';

import { useFieldContext } from '#form';
import { CountryIso2 } from 'react-international-phone';

import { LabelInput } from '@repo/ui/LabelInput';

const PhoneField = lazy(() => import('@repo/ui/PhoneField'));

interface InputProps {
	label: ReactNode;
	defaultCountry: CountryIso2;
	optional?: boolean;
}

export function PhoneInput({ label, defaultCountry, optional }: InputProps) {
	const field = useFieldContext<string | null | undefined>();
	const error = (
		field.state.meta as {
			errors?: Array<string | BaseIssue<unknown>>;
		}
	).errors?.[0];

	return (
		<LabelInput
			label={label}
			fieldName={field.name}
			labelEnd={optional ? <LabelInput.Optional /> : undefined}
		>
			<Suspense fallback={<Skeleton sx={{ height: 40, transform: 'none' }} />}>
				<PhoneField
					id={field.name}
					name={field.name}
					defaultCountry={defaultCountry}
					value={field.state.value ?? ''}
					onChange={field.handleChange}
					onBlur={field.handleBlur}
					error={error != null}
					helperText={
						error ?
							typeof error === 'string' ?
								error
							:	error.message
						:	''
					}
				/>
			</Suspense>
		</LabelInput>
	);
}
